import { SubmitTrainEventRecordModel, TrainEventRecordList } from "../models/api/models";
import appSettings from "../settings/appSettings";
import { httpGet, httpPost } from "./httpService";

const trainEventRecordUriPath = new URL('/api/rail-operations-forms', appSettings.api.portalApi);
const trainEventRecordSubmit = `${trainEventRecordUriPath}/submitTrainEvent`;
const trainEventRecordUserList = `${trainEventRecordUriPath}/UserTrainEventRecordList`;
const trainEventRecordAdminList = `${trainEventRecordUriPath}/AdminTrainEventRecordList`;


export const submitTrainEventRecord = async (form: SubmitTrainEventRecordModel) => {
    return await httpPost<number>(`${trainEventRecordSubmit}`, form)
        .catch(e => { console.log(e); return -1 });
};
export const getUserTrainEventList = async () => {
    return await httpGet<TrainEventRecordList[]>(trainEventRecordUserList.toString())
        .catch(e => { console.log(e); return [] as TrainEventRecordList[] });
}
export const getAdminTrainEventList = async () => {
    return await httpGet<TrainEventRecordList[]>(trainEventRecordUserList.toString())
        .catch(e => { console.log(e); return [] as TrainEventRecordList[] });
}